import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import "@theHescoBlueprint/Handlers/CustomShipViaAccountNumberReducer";
import { css } from "styled-components";

setPostStyleGuideTheme({
    // specifies primary colors are not editable & fixed to these values
    typography: {
        fontFamilyImportUrl: "https://fonts.googleapis.com/css2?family=Roboto&display=swap",
        body: {
            fontFamily: "'Calibri', 'Roboto', sans-serif",
        },
        headerPrimary: {
            fontFamily: "'Calibri', 'Roboto', sans-serif",
        },
        headerSecondary: {
            fontFamily: "'Calibri', 'Roboto', sans-serif",
        },
        headerTertiary: {
            fontFamily: "'Calibri', 'Roboto', sans-serif",
        },
        h1: {
            fontFamily: "'Calibri', 'Roboto', sans-serif",
            css: css`
                text-align: left;
                margin-bottom: 40px;
            `,
        },
        h2: {
            fontFamily: "'Calibri', 'Roboto', sans-serif",
            transform: "uppercase",
            css: css`
                margin: 15px 0;
            `,
        },
    },
    modal: {
        defaultProps: {
            cssOverrides: {
                modalBody: css`
                    > div[class^="ModalContent"] {
                        overflow-y: visible;
                    }
                `,
            },
        },
    },
    focus: {
        width: "1px",
    },
    button: {
        primary: {
            css: css`
                white-space: nowrap;
            `,
        },
        secondary: {
            hoverStyle: {
                backgroundColor: "#f3f3f3",
            },
        },
        tertiary: {
            hoverStyle: {
                backgroundColor: "#333",
            },
            css: css`
                border: none;
                border-right: 5px solid #036eb7 !important;
                padding: 10px 30px;
                min-height: auto;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 10px 20px;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    )}
                span {
                    line-height: initial;
                }
            `,
        },
    },
    checkbox: {
        defaultProps: {
            css: css`
                cursor: pointer;
                span[role="checkbox"] {
                    background: #fff;
                }
            `,
        },
    },
    datePicker: {
        defaultProps: {
            cssOverrides: {
                datePicker: css`
                    > div[class^="react-datetime-picker"] {
                        > div > div[class="react-datetime-picker__inputGroup"] {
                            pointer-events: none;
                        }
                    }
                `,
                inputSelect: css`
                    width: 100%;
                `,
                formField: css`
                    padding-right: 10px;
                    position: relative;
                    label {
                        position: absolute;
                        z-index: 1;
                        left: 20px;
                        background: #fff;
                        width: auto;
                        top: 0px;
                        min-height: auto;
                        & + div {
                            input,
                            select,
                            textarea {
                                background: #fff !important;
                                border-width: 1px !important;
                            }
                        }
                    }
                `,
            },
        },
    },
    formField: {
        defaultProps: {
            cssOverrides: {
                formField: css`
                    position: relative;
                    label {
                        position: absolute;
                        z-index: 1;
                        left: 20px;
                        background: #fff;
                        width: auto;
                        top: 3px;
                        line-height: 12px;
                        min-height: auto;
                        & + div[class^="FormInputWrapper"] {
                            input,
                            select,
                            textarea {
                                background: #fff !important;
                                border-width: 1px !important;
                                height: 40px;
                            }
                        }
                        div[class^="TooltipWrapper"] {
                            margin-top: -7px;
                        }
                    }
                `,
            },
        },
    },
    pagination: {
        defaultProps: {
            cssOverrides: {
                pagination: css`
                    align-items: flex-start;
                    margin: 0 !important;
                    padding-right: 15px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                null,
                                css`
                                    padding-right: 0;
                                    padding-top: 15px;
                                `,
                                null,
                            ],
                            "max",
                        );
                    }}
                    > span {
                        label {
                            background: none !important;
                        }
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        width: 50%;
                                        justify-content: flex-start;
                                    `,
                                    css`
                                        width: 30%;
                                        justify-content: flex-start;
                                    `,
                                    null,
                                ],
                                "max",
                            );
                        }}
                    }
                    > nav {
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        width: 50%;
                                        justify-content: flex-end;
                                    `,
                                    css`
                                        width: 70%;
                                        justify-content: flex-end;
                                    `,
                                    null,
                                ],
                                "max",
                            );
                        }}
                    }
                `,
            },
            selectProps: {
                cssOverrides: {
                    formField: css`
                        width: auto;
                        padding-right: 15px;
                        position: relative;
                    `,
                    formInputWrapper: css`
                        max-width: 75px;
                        position: static;
                        select {
                            font-size: 13px !important;
                            width: 55px !important;
                            & + span {
                                right: 10px !important;
                            }
                        }
                    `,
                },
                labelProps: {
                    css: css`
                        width: auto;
                    `,
                },
            },
        },
    },
    tooltip: {
        defaultProps: {
            cssOverrides: {
                tooltipContainer: css`
                    z-index: 2;
                `,
            },
        },
    },
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [540, 540, 732, 1024, 1440],
    },
});
